import React from "react";

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  color?: string;
  type?: "svg" | "png" | "jpg";
}

const Icon: React.FC<IconProps> = ({
  name,
  size,
  className = "",
  color = "currentColor",
  type = "svg",
}) => {
  // You can import your icons here based on the name
  const getIconPath = (iconName: string, iconType: string): string => {
    // This is where you'll map icon names to their file paths
    // Example mapping - adjust based on your actual icon package
    const iconMap: Record<string, string> = {
      home: `/icons/home.${iconType}`,
      user: `/icons/user.${iconType}`,
      settings: `/icons/settings.${iconType}`,
      search: `/icons/search.${iconType}`,
      menu: `/icons/menu.${iconType}`,
      close: `/icons/close.${iconType}`,
      "arrow-right": `/icons/arrow-right.${iconType}`,
      "arrow-left": `/icons/arrow-left.${iconType}`,
      download: `/icons/download.${iconType}`,
      share: `/icons/share.${iconType}`,
      community: `/icons/community.${iconType}`,
      money: `/icons/money.${iconType}`,
      android: `/icons/android.${iconType}`,
      apple: `/icons/apple.${iconType}`,
      "pahincho-logo": `/icons/icon-192.png`,
      "pahincho-logo-large": `/icons/icon-512.png`,
      // Add more mappings as needed
    };

    return iconMap[iconName] || `/icons/${iconName}.${iconType}`;
  };

  return (
    <img
      src={getIconPath(name, type)}
      alt={`${name} icon`}
      style={{
        ...(size != null ? { width: size, height: size } : {}),
        color: color,
      }}
      className={className}
    />
  );
};

export default Icon;
